<template>
    <div>
        <p class="text-primary font-weight-bold mb-0 text-uppercase" v-if="goal">
            {{
                `${target || target === 0 ? target + 1 + "/" : ""}${
                    target || target === 0 ? goal.parameters.targets.length : ""
                }`
            }}
            Select target
        </p>
        <div class="d-flex justify-content-start align-items-center" v-if="goal">
            <i
                class="fa fa-caret-left text-primary mr-3 cursor-pointer"
                @click="target > 0 ? target-- : null"
            ></i>
            <select
                v-model="target"
                class="form-control form-control-sm"
                name="domain"
                id="tracking"
            >
                <option
                    v-if="
                        results.filter(r => r || r === 0).length === goal.parameters.targets.length
                    "
                    value=""
                    disabled
                    hidden
                    :value="target"
                    >No target left</option
                >
                <option
                    v-for="t in goal.parameters.targets.filter(t => availableTargets.includes(t))"
                    :value="goal.parameters.targets.indexOf(t)"
                    >{{ t }}</option
                >
            </select>
            <i
                class="fa fa-caret-right text-primary ml-3 cursor-pointer"
                @click="target < goal.parameters.targets.length ? target++ : (target = 0)"
            ></i>
        </div>
        <div class="d-flex justify-content-start align-items-center px-3">
            <div v-if="!addTarget">
                <small
                    class="text-primary font-italic cursor-pointer align-self-end"
                    @click="addTarget = true"
                    >Add target</small
                >
            </div>
            <span class="row my-2" v-if="addTarget">
                <span class="col-7">
                    <input type="text" class="form-control form-control-sm" v-model="newTarget" />
                </span>
                <span class="col-2 px-0 d-flex justify-content-center">
                    <a class="text-primary btn btn-sm btn-outline-primary" @click="saveNewTarget()"
                        >Add</a
                    >
                </span>
                <span class="col-3 px-0 d-flex justify-content-center">
                    <a
                        class="text-primary btn btn-sm btn-outline-primary"
                        @click="addTarget = false"
                        >Cancel</a
                    >
                </span>
            </span>
        </div>

        <div class="variable-content">
            <prompt :iconset="iconset" :session="true" @select-prompt="addAttempt($event)"></prompt>

            <div class="row" v-if="goal">
                <ul class="col-9 pl-3">
                    <li class="pl-1 d-flex" v-for="(a, i) in detailed_results">
                        <span>{{ i + 1 }}. {{ goal.parameters.targets[i] }} </span>
                        <span
                            v-if="
                                detailed_results[i] === 0 ||
                                    (detailed_results[i] && !isNaN(detailed_results[i]))
                            "
                            class="ml-2"
                        >
                            <prompt
                                :mini="true"
                                :prompt="[null, iconset, detailed_results[i]]"
                            ></prompt>
                        </span>
                    </li>
                </ul>

                <div class="col-3">
                    <h4 class="pl-1">{{ successRate }}%</h4>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Prompt from "../../ui/PromptIcon";

export default {
    name: "Articulation",
    props: ["goal", "date", "customization", "flagData", "notesData"],
    components: { Prompt },
    data() {
        return {
            target: 0,
            previousTargets: [],
            availableTargets: [],
            addTarget: false,
            newTarget: null,
            results: [],
            detailed_results: [],
            saving: false,
            saved: false,
        };
    },
    created() {
        if (this.goal) {
            this.availableTargets = [...this.goal.parameters.targets];
        }
    },
    methods: {
        addAttempt(event) {
            if (this.availableTargets.length) {
                this.$set(this.results, this.target, event[0]);
                this.$set(this.detailed_results, this.target, event[1]);
                let i = this.availableTargets.indexOf(this.goal.parameters.targets[this.target]);
                this.availableTargets.splice(i, 1);
                let goalsAvailable = this.goal.parameters.targets.filter(t =>
                    this.availableTargets.includes(t)
                );
                let nextTarget = 0;
                if (goalsAvailable.length) {
                    nextTarget = this.goal.parameters.targets.indexOf(goalsAvailable[0]);
                }
                this.previousTargets.push(this.target);
                this.target = nextTarget;
            }
        },

        undoAttempt() {
            if (this.previousTargets.length) {
                let prev = this.previousTargets.pop();
                this.$set(this.results, prev, null);
                this.$set(this.detailed_results, prev, null);
                if (!this.availableTargets.includes(this.goal.parameters.targets[prev])) {
                    this.availableTargets.push(this.goal.parameters.targets[prev]);
                }
                this.target = prev;
            }
        },

        saveTrackerData() {
            const results = this.results.map((r, i) => `${this.goal.parameters.targets[i]}: ${r}`);
            const detailed_results = this.detailed_results.map(
                (r, i) => `${this.goal.parameters.targets[i]}: ${r}`
            );
            let data = {
                session_at: this.date
                    ? this.moment(this.date).format("YYYY-MM-DD HH:mm:ss")
                    : this.moment().format("YYYY-MM-DD HH:mm:ss"),
                notes: this.notesData,
                data: {
                    results,
                    detailed_results,
                    iconset: this.iconset,
                    type: this.goal.tracker_type,
                    success: this.successRate,
                },
                is_flagged: this.flagData,
            };
            axios
                .post(`/api/patients/${this.goal.patient.id}/goals/${this.goal.id}/trackers`, data)
                .then(r => {
                    this.reportResult(true);
                })
                .catch(error => {
                    this.$emit("save-draft", { error, data });
                    this.reportResult(false);
                    this.$swal({
                        title: "Error!",
                        text: "An error occurred while saving.",
                        type: "error",
                        confirmButtonText: "Close",
                        confirmButtonColor: "#d64571",
                    });
                    console.error(error);
                });
        },

        reportResult(success) {
            this.$emit("saved", success);
            if (success) {
                this.$emit(
                    "close-tracker",
                    this.goal.title + ": " + `Scored ${this.successRate}%` + " - " + this.notesData
                );
            }
        },

        saveNewTarget() {
            this.goal.parameters.targets.push(this.newTarget);
            this.availableTargets.push(this.newTarget);
            this.newTarget = null;
            this.addTarget = false;
        },
    },

    computed: {
        iconset() {
            return this.customization &&
                this.customization.hasOwnProperty("default_options") &&
                this.customization.default_options &&
                !isNaN(this.customization.default_options.iconset)
                ? this.customization.default_options.iconset
                : 0;
        },

        successRate() {
            if (this.results.length) {
                return parseInt((100 * this.results.filter(r => r).length) / this.results.length);
            }
        },
    },
};
</script>

<style scoped lang="scss">
.attempt-list {
    column-count: 3;
    column-gap: 0;
    list-style: none;

    > li {
        border-left: solid 1px #8f8f8f;
    }
}
h4 {
    border-left: solid 1px #8f8f8f;
}
</style>
